module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-05.053e1597.svg";